import { SiteLogo } from '@/components/layout/SiteLogo'
import { MainMenu } from '@/components/layout/MainMenu'
import { useWebsiteContact } from '@/services/httpServices/queries/useWebsite'

/**
 * Global header — based on the Home page (index-3.html) `header-3`, used on
 * every public page. The template's header top bar (coupon / social / search /
 * cart strip) is intentionally removed; the lower bar (logo, navigation,
 * booking button, emergency call, offcanvas toggler) is kept verbatim.
 */
export function HeaderThree() {
  const { contact } = useWebsiteContact()
  const phoneHref = `tel:${contact.phone.replace(/[^\d+]/g, '')}`

  return (
    <header className="header header-3">
      {/* header lower start */}
      <div className="header-lower">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between g-0">
            <div className="col-12">
              <div className="header-content d-flex justify-content-between align-items-center">
                <div className="logo-box">
                  <div className="logo">
                    <a href="/">
                      <figure>
                        <SiteLogo />
                      </figure>
                    </a>
                  </div>
                </div>

                <div className="header-navigation d-flex align-items-center justify-content-center">
                  <MainMenu />
                </div>

                <div className="header-right d-flex align-items-center justify-content-end">
                  <div className="header-button">
                    <a href="/report-check" className="theme-button style-1" aria-label="Report Check">
                      <span data-text="Report Check">Report Check</span>
                      <i className="fa-solid fa-file-medical"></i>
                    </a>
                  </div>
                  <div className="header-button">
                    <a href="/appointment" className="theme-button style-1" aria-label="Book Appointment">
                      <span data-text="Book Appointment">Book Appointment</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                  <div className="header-call">
                    <div className="header-call-icon">
                      <i className="fa-solid fa-phone-volume"></i>
                    </div>
                    <div className="header-call-content">
                      <span>For emergency, Call now</span>
                      <a href={phoneHref}>{contact.phone}</a>
                    </div>
                  </div>
                  <div className="header-sidebar">
                    <a
                      className="sidebar-toggler color-one"
                      data-bs-toggle="offcanvas"
                      href="#offcanvas-sidebar"
                      aria-label="sidebar toggler"
                      role="button"
                      aria-controls="offcanvas-sidebar"
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* header lower end */}
    </header>
  )
}
